import { useShallow } from 'zustand/shallow'

import { useStore } from '@app/store'
import type { DomainNode } from '@app/types'

type UseGetNode = (id: string) => DomainNode

const useGetNode: UseGetNode = (id) => useStore(useShallow((state) => state.getNodeById(id)))

export default useGetNode
